import React from "react";
import CalendarBlock from "./CalendarBlock";

const Calendar = ({ habit, handleDayClick }) => {
  return (
    <>
      {habit.days.map((day) => (
        <CalendarBlock
          key={Math.random() * 1000}
          id={habit.id}
          day={day.day}
          blockColor={day.color}
          handleDayClick={handleDayClick}
        />
      ))}
    </>
  );
};

export default Calendar;
